import { render, staticRenderFns } from "./solicitacao-pessoa-fisica.vue?vue&type=template&id=c0e0982a&"
import script from "./solicitacao-pessoa-fisica.vue?vue&type=script&lang=js&"
export * from "./solicitacao-pessoa-fisica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports